/**
 * Shared button reset styles for news card components
 */
export const buttonResetStyles: React.CSSProperties = {
  appearance: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  textAlign: 'left',
};

